<template>
  <div class="etms-waybill-body">
    <div>
      <div class="etms-waybill-header" @click="basicshow=!basicshow">基本信息 (单号、发货商、渠道、线路)</div>
      <div v-show="basicshow">
        <el-form label-width="20%" width="100%" class="el-form-half">
          <el-form-item label="客户单号：">
            <el-input size="mini" placeholder="请填写客户运单号" class="el-width-200" v-model="form.CustomerOdd"></el-input>
          </el-form-item>
          <el-form-item label="服务商单号：">
            <el-input size="mini" placeholder="请填写服务商单号" class="el-width-200" v-model="form.ServiceOdd"></el-input>
          </el-form-item>
          <el-form-item label="发货商：">
            <el-select size="mini" placeholder="请选择发货商" class="el-width-200" v-model="form.TargetEnterpriseId"></el-select>
          </el-form-item>
          <el-form-item label="渠道：">
            <el-select size="mini" placeholder="请选择发货渠道" class="el-width-200" v-model="form.ChannelId"></el-select>
          </el-form-item>
          <el-form-item label="包裹分类：">
            <el-select size="mini" placeholder="请选择包裹分类" class="el-width-200" v-model="form.ParcelTypeId"></el-select>
          </el-form-item>
          <el-form-item label="是否需要退件：">
            <el-select size="mini" placeholder="发生问题时是否需要退回" class="el-width-200" v-model="form.NeedReturnState">
              <el-option value="true" label="需要"></el-option>
              <el-option value="false" label="不需要"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="ShipmentAirPortDepotTitle" v-show="shipmentshow">
            <el-select size="mini" :placeholder="ShipmentAirPortDeportPlaceholder" class="el-width-200" v-model="form.ShipmentAirPortDepotId" :disabled="ShipmentAirPortDeportDisabled"></el-select>
          </el-form-item>
          <div class="clear"></div>
        </el-form>
      </div>
      <div class="etms-waybill-header" @click="receiptshow=!receiptshow">收货方(填写完整、准确信息，物流跟进更及时)</div>
      <div v-show="receiptshow">
        <el-form label-width="20%" width="100%" class="el-form-half">
          <el-form-item label="联系人：">
            <el-input size="mini" placeholder="请填写收货人姓名" class="el-width-200" v-model="form.ReceiptName"></el-input>
            <el-checkbox>存至地址库</el-checkbox>
          </el-form-item>
          <el-form-item label="公司：">
            <el-input size="mini" placeholder="请填写收货人公司名称" class="el-width-200" v-model="form.ReceiptCompanyName"></el-input>
          </el-form-item>
          <el-form-item label="国家：">
            <el-select size="mini" placeholder="货物最终送往的国家" class="el-width-200" v-model="form.PurposeRegionId"></el-select>
          </el-form-item>
          <el-form-item :label="PurposeAirPortDepotTitle" v-show="purposeshow">
            <el-select size="mini" :placeholder="PurposeAirPortDepotPlaceholder" class="el-width-200" v-model="form.PurposeAirPortDepotId" :disabled="PurposeAirPortDepotDisabled"></el-select>
          </el-form-item>
          <el-form-item label="收货方地区：">
            <el-select size="mini" placeholder="州省" class="el-width-70" v-model="form.ReceiptState" filterable allow-create default-first-option></el-select>
            <el-select size="mini" placeholder="城市" class="el-width-70" v-model="form.ReceiptCity" filterable allow-create default-first-option></el-select>
            <el-select size="mini" placeholder="区县" class="el-width-70" v-model="form.ReceiptCounty" filterable allow-create default-first-option></el-select>
          </el-form-item>
          <el-form-item label="街道：">
            <el-input size="mini" placeholder="请填写收货方街道" class="el-width-200" v-model="form.ReceiptStreet"></el-input>
          </el-form-item>
          <el-form-item label="详细地址：">
            <el-input size="mini" placeholder="请填写收货方详细地址" class="el-width-300" v-model="form.ReceiptAddress"></el-input>
          </el-form-item>
          <el-form-item label="备用地址：">
            <el-input size="mini" placeholder="请填写收货方详细地址" class="el-width-300" v-model="form.ReceiptStandbyAddress"></el-input>
          </el-form-item>
          <el-form-item label="手机：">
            <el-input size="mini" placeholder="请填写收货方手机号码" class="el-width-200" v-model="form.ReceiptMobile"></el-input>
          </el-form-item>
          <el-form-item label="电话：">
            <el-input size="mini" placeholder="请填写收货方联系电话号码" class="el-width-200" v-model="form.ReceiptPhone"></el-input>
          </el-form-item>
          <el-form-item label="传真：">
            <el-input size="mini" placeholder="请填写收货方传真号码" class="el-width-200" v-model="form.ReceiptFax"></el-input>
          </el-form-item>
          <el-form-item label="邮箱：">
            <el-input size="mini" placeholder="请填写收货方邮箱号码" class="el-width-200" v-model="form.ReceiptEmail"></el-input>
          </el-form-item>
          <el-form-item label="邮编：">
            <el-input size="mini" placeholder="请填写收货地址邮政编码" class="el-width-200" v-model="form.BuyerZipcode"></el-input>
          </el-form-item>
          <el-form-item label="买家ID：">
            <el-input size="mini" placeholder="请填写收货方所在平台帐号ID" class="el-width-200" v-model="form.BuyerCode"></el-input>
          </el-form-item>
          <div class="clear"></div>
        </el-form>
      </div>
      <div class="etms-waybill-header" @click="sendershow=!sendershow">发货方(为了您货物安全，请填写完整、准确信息)</div>
      <div v-show="sendershow">
        <el-form label-width="20%" width="100%" class="el-form-half">
          <el-form-item label="联系人：">
            <el-input size="mini" placeholder="请填写发货方联系人姓名" class="el-width-200" v-model="form.SenderName"></el-input>
            <el-checkbox>存至地址库</el-checkbox>
          </el-form-item>
          <el-form-item label="公司：">
            <el-input size="mini" placeholder="请填写发货人公司名称" class="el-width-200" v-model="form.SenderCompanyName"></el-input>
          </el-form-item>

          <el-form-item label="地区：">
            <el-cascader size="mini" placeholder="请选择发货方所在地区" :options="regions" v-model="form.SenderRegions" filterable class="el-width-200"></el-cascader>
          </el-form-item>
          <el-form-item label="街道：">
            <el-input size="mini" placeholder="请填写发货方街道" class="el-width-200" v-model="form.SenderStreet"></el-input>
          </el-form-item>
          <el-form-item label="详细地址：">
            <el-input size="mini" placeholder="请填写发货方详细地址" class="el-width-300" v-model="form.SenderAddress"></el-input>
          </el-form-item>
          <el-form-item label="备用地址：">
            <el-input size="mini" placeholder="请填写发货方备用详细地址" class="el-width-300" v-model="form.SenderStandbyAddress"></el-input>
          </el-form-item>
          <el-form-item label="手机：">
            <el-input size="mini" placeholder="请填写发货方手机号码" class="el-width-200" v-model="form.SenderMobile"></el-input>
          </el-form-item>
          <el-form-item label="电话：">
            <el-input size="mini" placeholder="请填写发货方联系电话号码" class="el-width-200" v-model="form.SenderPhone"></el-input>
          </el-form-item>
          <el-form-item label="传真：">
            <el-input size="mini" placeholder="请填写发货方传真号码" class="el-width-200" v-model="form.SenderFax"></el-input>
          </el-form-item>
          <el-form-item label="邮箱：">
            <el-input size="mini" placeholder="请填写发货方邮箱号码" class="el-width-200" v-model="form.SenderEmaill"></el-input>
          </el-form-item>
          <el-form-item label="邮编：">
            <el-input size="mini" placeholder="请填写发货地址邮政编码" class="el-width-200" v-model="form.SenderZipcode"></el-input>
          </el-form-item>
          <el-form-item label="卖家ID：">
            <el-input size="mini" placeholder="请填写发货方所在平台帐号ID" class="el-width-200" v-model="form.SellerCode"></el-input>
          </el-form-item>
          <div class="clear"></div>
        </el-form>
      </div>
      <div class="etms-waybill-header" @click="parcelshow=!parcelshow">货物信息</div>
      <el-table :data="form.Parcels" :border="true" v-show="parcelshow" class="etms-router-list">
        <el-table-column label="编号" type="index" header-align="center" align="center"></el-table-column>
        <el-table-column label="箱号" prop="CaseNumber">
          <template slot-scope="scope">
            <el-input size="mini" placeholder="选填" v-model="scope.row.CaseNumber" class="el-width-100"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="子单号" prop="ParcelOdd">
          <template slot-scope="scope">
            <el-input size="mini" placeholder="选填" v-model="scope.row.ParcelOdd" class="el-width-100"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="重量" prop="ParcelConfirmWeight">
          <template slot-scope="scope">
            <el-input size="mini" placeholder="必填" type="number" v-model="scope.row.ParcelConfirmWeight" class="el-width-70"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="长" prop="ParcelConfirmLong">
          <template slot-scope="scope">
            <el-input size="mini" placeholder="选填" type="number" v-model="scope.row.ParcelConfirmLong" class="el-width-70"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="宽" prop="ParcelConfirmWide">
          <template slot-scope="scope">
            <el-input size="mini" placeholder="选填" type="number" v-model="scope.row.ParcelConfirmWide" class="el-width-70"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="高" prop="ParcelConfirmHigh">
          <template slot-scope="scope">
            <el-input size="mini" placeholder="选填" type="number" v-model="scope.row.ParcelConfirmHigh" class="el-width-70"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="体积重" prop="ParcelConfirmVolumeWeight"></el-table-column>
        <el-table-column align="center" width="150px">
          <template slot="header" slot-scope="scope">
            <el-tooltip class="item" effect="dark" content="添加货物信息" placement="top">
              <el-button size="mini" type="primary" icon="el-icon-plus" circle @click="insertParcel"></el-button>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" content="删除此货物" placement="top">
              <el-button size="mini" type="danger" @click.native.prevent="handleParcelDelete(scope.$index, form.Parcels)" icon="el-icon-delete" circle></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="etms-waybill-header" @click="customsshow=!customsshow">海关申报信息</div>
    <el-table :data="form.Customs" :border="true" v-show="customsshow" class="etms-router-list">
      <el-table-column label="编号" type="index" header-align="center" align="center"></el-table-column>
      <el-table-column label="中文品名" prop="DeclareName_CN">
        <template slot-scope="scope">
          <el-input size="mini" placeholder="必填" v-model="scope.row.DeclareName_CN" class="el-width-100"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="英文品名" prop="DeclareName_EN">
        <template slot-scope="scope">
          <el-input size="mini" placeholder="必填" v-model="scope.row.DeclareName_EN" class="el-width-100"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="材质" prop="Material">
        <template slot-scope="scope">
          <el-input size="mini" placeholder="选填" v-model="scope.row.Material" class="el-width-100"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="用途" prop="Purpose">
        <template slot-scope="scope">
          <el-input size="mini" placeholder="选填" v-model="scope.row.Purpose" class="el-width-100"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="数量" prop="DeclareQuantity">
        <template slot-scope="scope">
          <el-input size="mini" placeholder="必填" v-model="scope.row.DeclareQuantity" class="el-width-70"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="单价" prop="DeclareUnitPrice">
        <template slot-scope="scope">
          <el-input size="mini" placeholder="必填" v-model="scope.row.DeclareUnitPrice" class="el-width-70"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="配货信息" prop="ProductInfo">
        <template slot-scope="scope">
          <el-input size="mini" placeholder="选填" v-model="scope.row.ProductInfo" class="el-width-100"></el-input>
        </template>
      </el-table-column>
      <el-table-column align="center" width="150px">
        <template slot="header" slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="添加海关申报信息" placement="top">
            <el-button size="mini" type="primary" icon="el-icon-plus" circle @click="insertCustoms"></el-button>
          </el-tooltip>
        </template>
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="添加更多申报信息" placement="top">
            <el-button size="mini" type="primary" @click="handleCustomsMore(scope.$index,scope.row)" icon="el-icon-more" circle></el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="删除此申报信息" placement="top">
            <el-button size="mini" type="danger" @click="handleCustomsDelete(scope.$index, form.Customs)" icon="el-icon-delete" circle></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog :visible.sync="customsmore" :modal-append-to-body="false" width="500px" center>
      <el-form :model="customsmodel" ref="customsform" label-width="120px" class="etms-dialog-form">
        <el-form-item label="海关编码：">
          <el-input size="mini" placeholder="选填" class="el-width-250" v-model="customsmodel.CustomsCode"></el-input>
        </el-form-item>
        <el-form-item label="产品SKU：">
          <el-input size="mini" placeholder="选填" class="el-width-250" v-model="customsmodel.ProductSKU"></el-input>
        </el-form-item>
        <el-form-item label="税号：">
          <el-input size="mini" placeholder="选填" class="el-width-250" v-model="customsmodel.InvoiceTaxno"></el-input>
        </el-form-item>
        <el-form-item label="平台产品ID：">
          <el-input size="mini" placeholder="选填" class="el-width-250" v-model="customsmodel.PlatformProductId"></el-input>
        </el-form-item>
        <el-form-item label="规格：">
          <el-input size="mini" placeholder="选填" class="el-width-250" v-model="customsmodel.Spec"></el-input>
        </el-form-item>
        <el-form-item label="产地：">
          <el-input size="mini" placeholder="选填" class="el-width-250" v-model="customsmodel.Origin"></el-input>
        </el-form-item>
        <el-form-item label="品牌：">
          <el-input size="mini" placeholder="选填" class="el-width-250" v-model="customsmodel.Brand"></el-input>
        </el-form-item>
        <el-form-item label="平台产品链接：">
          <el-input size="mini" placeholder="选填" class="el-width-250" v-model="customsmodel.ProductLink"></el-input>
        </el-form-item>
        <el-form-item label="产品图片链接：">
          <el-input size="mini" placeholder="选填" class="el-width-250" v-model="customsmodel.ImageLink"></el-input>
        </el-form-item>
        <el-form-item label="币种：">
          <el-select size="mini" placeholder="币种选填" class="el-width-100" v-model="customsmodel.Currency">
            <el-option v-for="item in Currencys" :label="item" :value="item" :key="item"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="customsmore=false">取 消</el-button>
        <el-button size="mini" type="primary" @click="dialogSave">确 定</el-button>
      </div>
    </el-dialog>
    <div class="el-footer-div">
      <el-button size="mini" type="primary" @click="waybillSubmit">提交</el-button>
    </div>
  </div>
</template>

<script>

export default {
  data () {
    return {
      regions: this.regionmodule.regions,
      Currencys: this.constant.Currencys,
      formname: 'deliveryform',
      basicshow: true,
      receiptshow: true,
      sendershow: false,
      parcelshow: true,
      customsshow: true,
      purposeshow: false,
      shipmentshow: false,
      PurposeAirPortDepotTitle: '机场：',
      PurposeAirPortDepotPlaceholder: '最终送达的机场(可空)',
      PurposeAirPortDepotDisabled: true,
      ShipmentAirPortDepotTitle: '机场：',
      ShipmentAirPortDeportPlaceholder: '起运机场(可空)',
      ShipmentAirPortDeportDisabled: true,
      customsmore: false,
      customsmodel: {
        Index: '',
        DeclareName_CN: '',
        DeclareName_EN: '',
        DeclareQuantity: '',
        DeclareUnitPrice: '',
        CustomsCode: '',
        ProductInfo: '',
        ProductSKU: '',
        ProductLink: '',
        ProductId: '',
        ProductLink: '',
        ImageLink: '',
        Material: '',
        Purpose: '',
        Currency: '',
        InvoiceTaxno: '',
        Spec: '',
        Origin: '',
        Brand: '',
        PlatformProductId: ''
      },
      form: {
        CustomerOdd: '',
        ServiceOdd: '',
        TargetEnterpriseId: '',
        ChannelId: '',
        ParcelTypeId: '',
        NeedReturnState: '',
        ReceiptName: '',
        ReceiptCompanyName: '',
        PurposeRegionId: '',
        ReceiptState: '',
        ReceiptCity: '',
        ReceiptCounty: '',
        ReceiptStreet: '',
        ReceiptAddress: '',
        ReceiptStandbyAddress: '',
        ReceiptMobile: '',
        ReceiptPhone: '',
        ReceiptFax: '',
        ReceiptEmail: '',
        BuyerZipcode: '',
        BuyerCode: '',
        SenderName: '',
        SenderCompanyName: '',
        ShipmentAirPortDepotId: '',
        ShipmentRegionId: '',
        SenderRegions: [],
        SenderStreet: '',
        SenderAddress: '',
        SenderStandbyAddress: '',
        SenderPhone: '',
        SenderMobile: '',
        SenderEmaill: '',
        SenderFax: '',
        SenderZipcode: '',
        SellerCode: '',
        Parcels: [],
        Customs: []
      }, rules: {}
    }
  },
  mounted(){
    alert(this.$route.params.enterpriseid)
  },
  methods: {
    insertParcel () {
      if (this.form.Parcels.filter(item => item.ParcelConfirmWeight === '' || item.ParcelConfirmWeight <= 0).length > 0) {
        this.$message.error('存在不完整的货物信息,不可再次添加货物信息')
        return
      }

      this.form.Parcels.push({
        Index: this.form.Parcels.length + 1,
        CaseNumber: '',
        ParcelOdd: '',
        ParcelConfirmLong: '',
        ParcelConfirmWide: '',
        ParcelConfirmHigh: '',
        ParcelConfirmWeight: '',
        ParcelConfirmVolumeWeight: ''
      });
    },
    handleParcelDelete (index, row) {
      row.splice(index, 1)
    },
    handleCustomsMore (index, row) {
      this.customsmore = true
      var model = this.form.Customs.filter(item => item.Index === row.Index)[0]
      if (model !== null && model !== undefined) {
        this.customsmodel = model
        console.log('1-1', this.customsmodel)
        console.log('2-2', model)
      }
      console.log(row.Index, model.Index)
    },
    insertCustoms () {
      if (this.form.Customs.filter(item => item.DeclareName_CN === '' || item.DeclareName_EN === '' || item.DeclareQuantity <= 0 || item.DeclareUnitPrice <= 0).length > 0) {
        this.$message.error('存在不完整的报关信息,不可再次添加报关信息')
        return
      }
      this.form.Customs.push({
        Index: this.form.Customs.length + 1,
        DeclareName_CN: '',
        DeclareName_EN: '',
        DeclareQuantity: '',
        DeclareUnitPrice: '',
        CustomsCode: '',
        ProductInfo: '',
        ProductSKU: '',
        ProductLink: '',
        ProductId: '',
        ProductLink: '',
        ImageLink: '',
        Material: '',
        Purpose: '',
        Currency: '',
        InvoiceTaxno: '',
        Spec: '',
        Origin: '',
        Brand: '',
        PlatformProductId: ''
      })
    },
    handleCustomsDelete (index, row) {
      row.splice(index, 1)
    },
    dialogSave () {
      this.form.Customs.filter(item => item.Index === this.customsmodel.Index)[0] = this.customsmodel
      this.customsmore = false
    },
    waybillSubmit () { }
  }
}
</script>

<style scoped>
@import "../../../css/etms/home.css";
@import "../../../css/iconfont.css";


</style>



// WEBPACK FOOTER //
// src/components/etms/ctms/create_delivery.vue